(ns frontend.ui.component.select-input.view
  "Key concepts to understand to work with inputs:

   From https://reactjs.org/docs/forms.html#controlled-components :

   > In HTML, form elements such as <input>, <textarea>, and <select> typically
   > maintain their own state and update it based on user input. In React, mutable
   > state is typically kept in the state property of components, and only updated
   > with setState().

   > We can combine the two by making the React state be the “single source of
   > truth”. Then the React component that renders a form also controls what
   > happens in that form on subsequent user input. An input form element whose
   > value is controlled by React in this way is called a “controlled component”

   This component is such a \"controlled component\" as we set field `:value` (and
   `on-change`)."
  (:require
   ["react-select" :default Select]
   [reagent.core :as r]
   [frontend.ui.component.select-input.style :as style]))

(def react-select-comp (r/adapt-react-class Select))

(defn ->js-option
  [[value label]]
  ;; Intentionally not using `clj->js` for speed
  ;; https://blog.fikesfarm.com/posts/2017-11-09-avoid-converting-javascript-objects.html
  ;; TODO could potentially be applied in many other places over the codebase
  (let [res #js {"value" value "label" label}]
    res))

(defn value-single
  [options value]
  (let [res (->js-option [value (get options value)])]
    res))

(defn- value-multi
  [options value]
  (map #(->js-option [% (get options %)])
       value))

(defn- on-change-single
  [on-change new-value]
  (on-change (.-value new-value)))

(defn- on-change-multi
  [on-change new-options _action-meta]
  (on-change (map #(.-value %) new-options)))

(defn select-input
  "HTML input with type `select`.
  - `options`: map of id (string) to label (string)
  - `value`: the selected value
  - if `multi?` is `true`, `value` must be seqable"
  [{:keys [multi? is-fixed? menu-portal-target input-value on-input-change value on-change
           name-sort?]}
   options]
  (let [options-lookup (if (map? options)
                         options
                         (into {} options))]
    [react-select-comp
     (merge
      {:styles           style/custom-styles
       :isMulti          multi?
       :menuPortalTarget (.getElementById js/document "react-select-menu-container")
       :menuPosition     "absolute"
       :options          (if name-sort?
                           (->> options
                                (sort-by val)
                                (map ->js-option))
                           (->> options
                                (map ->js-option)))
      }
      (when (fn? on-input-change)
        {:inputValue    (or input-value "")
         :onInputChange on-input-change})
      (if multi?
        {:value    (value-multi options-lookup value)
         :onChange (partial on-change-multi on-change)}
        {:value    (value-single options-lookup value)
         :onChange (partial on-change-single on-change)}))]))
